import type { RamonAction } from './types';

export const POSITIVE_REACTIONS = ['celebrate', 'dance', 'proud', 'hello_short', 'acknowledge'] as const;
/** Random variation without immediate repetition; no effect on rewards or copy. */
export function nextPositiveReaction(previous: RamonAction | null, random = Math.random): RamonAction {
  const choices = POSITIVE_REACTIONS.filter(action => action !== previous);
  return choices[Math.min(choices.length - 1, Math.max(0, Math.floor(random() * choices.length)))];
}
